class ExpandableFacts {
    constructor(expandableFact) {
        const expandableContent = expandableFact.querySelector('.expandable-facts__expandable');
        const button = expandableFact.querySelector('.expandable-facts__link--expand');

        if (button) {
            button.addEventListener('click', () => {
                const textElement = button.querySelector('span');
                const iconElement = button.querySelector('i');
                const isHidden = expandableContent.classList.contains('expandable-facts__expandable--hidden');

                if (isHidden) {
                    expandableContent.classList.remove('expandable-facts__expandable--hidden');
                    iconElement.classList.replace('fa-plus', 'fa-minus');
                    textElement.textContent = 'Stäng';
                }
                else {
                    expandableContent.classList.add('expandable-facts__expandable--hidden');
                    iconElement.classList.replace('fa-minus', 'fa-plus');
                    textElement.textContent = button.dataset.opentext;
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const expandableFacts = [...document.querySelectorAll('.expandable-facts')];
    if (expandableFacts) {
        expandableFacts.map((expandableFact) => {
            new ExpandableFacts(expandableFact);
        });
    }
});